/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
(function () {
  function infiniteOptionsValid() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return true;

    const fields = form.querySelectorAll(
      'select[name^="properties"], input[name^="properties"]'
    );

    for (let field of fields) {
      if (
        field.disabled ||
        field.type === "hidden" ||
        field.offsetParent === null
      ) {
        continue;
      }

      if (!field.value || field.value.toLowerCase() === "select") {
        return false;
      }
    }
    return true;
  }

  // 🔒 BLOCK FETCH (Broadcast uses fetch)
  const originalFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];

    if (typeof url === "string" && url.includes("/cart/add")) {
      if (!infiniteOptionsValid()) {
        alert("Please select size, sleeve length, and abaya length before adding to cart.");
        return Promise.reject("Blocked: options not selected");
      }
    }
    return originalFetch.apply(this, arguments);
  };

  // 🔒 BLOCK XHR (backup safety net)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this._url = arguments[1];
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._url && this._url.includes("/cart/add")) {
      if (!infiniteOptionsValid()) {
        alert("Please select size, sleeve length, and abaya length before adding to cart.");
        return;
      }
    }
    return originalSend.apply(this, arguments);
  };
})();



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
